<div class="s09-panel s09-tpl">
  <div class="s09-panel-head">
    <div>
      <h2>Templates</h2>
      <p class="s09-panel-sub">Scripts used by outreach attempts and FRM prompts.</p>
    </div>
    <div class="s09-panel-actions">
      <button type="button" class="s09-btn" (click)="newTemplate()">New</button>
      <button type="button" class="s09-btn-create" [disabled]="saving" (click)="save()">
        {{ saving ? 'Saving…' : (dirty ? 'Save*' : 'Save') }}
      </button>
      <button
        type="button"
        class="s09-btn s09-btn-danger"
        *ngIf="selectedCode"
        (click)="remove()">
        Delete
      </button>
    </div>
  </div>

  <p class="s09-panel-hint" *ngIf="hint">{{ hint }}</p>
  <p class="s09-panel-hint" *ngIf="loading">Loading templates…</p>

  <div class="s09-tpl-grid">
    <aside class="s09-tpl-list">
      <input
        class="s09-tpl-search"
        type="search"
        placeholder="Filter…"
        [(ngModel)]="filter" />
      <button
        type="button"
        class="s09-tpl-item"
        *ngFor="let t of filtered"
        [class.active]="t.template_code === selectedCode"
        (click)="select(t)">
        <strong>{{ t.template_name }}</strong>
        <span>{{ t.template_code }}</span>
        <em>{{ t.kind }} · {{ sourceLabel(t) }}</em>
      </button>
      <div class="s09-panel-hint" *ngIf="!loading && !filtered.length">No templates.</div>
    </aside>

    <section class="s09-tpl-form">
      <div class="s09-tpl-form-h">
        <h3>Edit</h3>
        <span class="s09-panel-hint" *ngIf="draft.template_code">{{ draft.template_code }}</span>
      </div>

      <div class="s09-field-row">
        <label class="s09-field">
          <span>Code</span>
          <input
            [(ngModel)]="draft.template_code"
            [readonly]="!!selectedCode"
            (ngModelChange)="onFieldEdit()"
            placeholder="e.g. TPL-A" />
        </label>
        <label class="s09-field">
          <span>Name</span>
          <input
            [(ngModel)]="draft.template_name"
            (ngModelChange)="onFieldEdit()"
            placeholder="Display name" />
        </label>
      </div>

      <div class="s09-field-row">
        <label class="s09-field">
          <span>Kind</span>
          <select [(ngModel)]="draft.kind" (ngModelChange)="onKindChange()">
            <option *ngFor="let k of kinds" [value]="k">{{ k }}</option>
          </select>
          <small *ngIf="isEmail">Shows To / Cc / Subject in preview.</small>
          <small *ngIf="!isEmail">Subject is hidden for {{ draft.kind }}.</small>
        </label>
        <label class="s09-field">
          <span>Source</span>
          <select [(ngModel)]="draft.source_status" (ngModelChange)="onSourceChange()">
            <option value="doc">Approved (doc)</option>
            <option value="draft">Draft — needs approval</option>
          </select>
          <small>Approved = process-map copy; Draft = not ready for go-live.</small>
        </label>
      </div>

      <label class="s09-field" *ngIf="isEmail">
        <span>Subject</span>
        <input
          [(ngModel)]="draft.subject"
          (ngModelChange)="onFieldEdit()"
          placeholder="Email subject" />
        <small>No PHI in subject lines.</small>
      </label>

      <label class="s09-field s09-field-grow">
        <span>Body</span>
        <textarea
          #bodyArea
          [(ngModel)]="draft.body"
          (ngModelChange)="onFieldEdit()"
          rows="12"
          placeholder="Template body — click a merge field below to insert"></textarea>
      </label>

      <div class="s09-field">
        <span>Merge fields</span>
        <div class="s09-merge-chips">
          <button
            type="button"
            class="s09-merge-chip"
            *ngFor="let key of mergeKeys"
            [class.phi]="isPhiField(key)"
            [title]="isPhiField(key) ? 'PHI-governed: name only with consent' : 'Insert into body'"
            (click)="insertMerge(key)">
            [{{ key }}]
          </button>
        </div>
        <small>
          [Patient ref] and [Chased party] use the patient name only when PHI consent is on;
          otherwise the case ID. Click a chip to insert at the cursor.
        </small>
      </div>
    </section>

    <section class="s09-tpl-preview">
      <div class="s09-tpl-form-h">
        <div class="s09-tpl-preview-label">Preview</div>
        <span class="s09-panel-hint">Sample office, not real data</span>
      </div>

      <label class="s09-tpl-toggle">
        <input type="checkbox" [(ngModel)]="previewPhi" />
        PATIENT_PHI_CONSENT_FLAG = Y
      </label>

      <label class="s09-field">
        <span>Who is being chased</span>
        <select [(ngModel)]="previewChase">
          <option value="patient">Patient (PH03.x)</option>
          <option value="office">Office / HCP (PH02.x)</option>
        </select>
      </label>

      <div class="s09-mail" *ngIf="isEmail">
        <div class="s09-mail-h">
          <div><span class="k">To</span> {{ previewTo }}</div>
          <div><span class="k">Cc</span> {{ previewCc }}</div>
          <div *ngIf="previewSubject"><span class="k">Subject</span> <b>{{ previewSubject }}</b></div>
        </div>
        <pre class="s09-tpl-preview-body">{{ previewBody || '—' }}</pre>
      </div>

      <div class="s09-mail" *ngIf="!isEmail">
        <div class="s09-mail-h"><b>{{ draft.kind }}</b></div>
        <pre class="s09-tpl-preview-body">{{ previewBody || '—' }}</pre>
      </div>
    </section>
  </div>
</div>
